<template>
    <div
        v-if="data && Object.keys(data).length"
        class="cart-product__container"
    >
        <div
            v-if="data.errors && data.errors.length"
            class="cart-product__error h3"
        >
            <span v-for="(error, index) in data.errors" :key="index">
                {{ error }}
            </span>
        </div>
        <div class="cart-product__item">
            <div v-if="data.imgUrl" class="cart-product__img">
                <img
                    v-if="data.rx"
                    :src="
                        getSkinUrl('images/catalog/product/recipe/recepta1.png')
                    "
                    width="205"
                    height="225"
                    :alt="data.productName ? data.productName : ''"
                />
                <img
                    v-else
                    :src="data.imgUrl"
                    :alt="data.productName ? data.productName : ''"
                />
            </div>
            <div class="cart-product__summary">
                <h3 v-if="data.productName" class="cart-product__name">
                    {{ data.productName }}
                </h3>
                <div v-if="data.price" class="cart-product__total">
                    {{ `${data.qty} szt.` }}
                    <span class="x">x</span>
                    {{ `${data.price} zł` }}
                </div>
            </div>
        </div>

        <div
            v-if="data.rx"
            class="cart-product__warning cart-product__warning-text"
        >
            Aby odebrać produkt w aptece, należy okazać receptę lub podać
            4-cyfrowy kod oraz PESEL.
        </div>
    </div>
</template>

<script>
import icons from '@js/app/icons.js'

export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        if (this.$el.length !== 0) {
            icons(this.$el)
        }
    }
}
</script>

<style lang="scss">
$mobile: '#{$media-xs}, #{$screen} and (max-width: #{$screen-sm-max}) and (orientation: landscape)';

.add-to-cart-wrapper {
    .custom-modal section.custom-modal-header {
        margin-top: 30px;
        margin-bottom: 40px;

        @media #{$mobile} {
            margin-bottom: 25px;
        }

        .custom-modal-title {
            font-size: 20px;
            border-bottom: 1px solid #daede1;

            @media #{$mobile} {
                font-size: 18px;
                margin-top: 100px;
                line-height: 24px;
                padding-bottom: 8px;
            }
        }
    }

    .custom-modal section.custom-modal-content {
        margin-top: 16px;
        margin-bottom: 16px;

        @media #{$mobile} {
            margin-bottom: 14px;
        }

        .cart-product__item {
            justify-content: left;
        }

        .cart-product__name {
            @media #{$mobile} {
                font-size: 14px;
                line-height: 22px;
                text-align: left;
                margin-bottom: 8px;
            }
        }

        .cart-product__total {
            @media #{$mobile} {
                margin-top: 0;
                font-size: 14px;
                line-height: 22px;
                text-align: left;
            }
        }
    }

    .custom-modal section.custom-modal-actions {
        margin: 0 0 15px 0;

        button:first-child,
        button + button {
            width: 280px;
            margin: 0 auto;
        }
    }

    .custom-modal section.custom-modal-footer {
        margin: 0 16px;
    }
}

.cart-product {
    &__container {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 480px;
        margin: 0 auto;
    }

    &__img {
        width: 120px;
        margin-right: 30px;
        flex-shrink: 0;

        @media #{$media-xs} {
            width: 80px;
            margin-right: 20px;
        }
    }

    &__summary {
        width: calc(100% - 120px - 30px);

        @media #{$media-xs} {
            width: calc(100% - 80px - 15px);
        }
    }

    &__name {
        font-size: 14px;
        line-height: 24px;
        color: #000;

        @media #{$media-sm-up} {
            font-size: 17px;
        }

        @media #{$media-xs} {
            text-align: center;
        }
    }

    &__total {
        font-size: 27px;
        color: $blue-dianne;

        @media #{$media-xs} {
            margin-top: 15px;
            font-size: 24px;
            clear: both;
            text-align: center;
        }

        .x {
            display: inline-block;
            margin: 0 10px;
        }
    }

    &__warning,
    &__error {
        width: 100%;
        background-color: #e9ecf4;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 45px;
        padding-right: 25px;

        @include n-theme() {
            border-bottom: 2px solid theme(color-primary);
        }

        .badge-icon {
            margin-right: -10px;
            margin-bottom: -10px;
            filter: brightness(0) saturate(100%) invert(20%) sepia(86%)
                saturate(5619%) hue-rotate(151deg) brightness(94%)
                contrast(102%);

            span {
                width: 50px;
                height: 50px;
                position: relative;
            }

            img {
                filter: brightness(0) saturate(100%) invert(20%) sepia(86%)
                    saturate(5619%) hue-rotate(151deg) brightness(94%)
                    contrast(102%);
                position: absolute;
                top: 0;
                width: 50px;
                height: 50px;
            }
        }

        p {
            margin: 0;
            text-align: center;
            @include n-theme() {
                color: theme(color-primary);
            }
        }
    }

    &__warning-text.cart-product__warning {
        border: 0;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.0008 16.5C12.1426 16.5 12.2612 16.4521 12.3567 16.3562C12.4522 16.2604 12.5 16.1417 12.5 16V11.5C12.5 11.3583 12.452 11.2396 12.356 11.1438C12.26 11.0479 12.1411 11 11.9993 11C11.8574 11 11.7388 11.0479 11.6433 11.1438C11.5478 11.2396 11.5 11.3583 11.5 11.5V16C11.5 16.1417 11.548 16.2604 11.644 16.3562C11.74 16.4521 11.8589 16.5 12.0008 16.5ZM12 9.577C12.1743 9.577 12.3205 9.518 12.4385 9.4C12.5565 9.282 12.6155 9.13583 12.6155 8.9615C12.6155 8.78717 12.5565 8.641 12.4385 8.523C12.3205 8.40517 12.1743 8.34625 12 8.34625C11.8257 8.34625 11.6795 8.40517 11.5615 8.523C11.4435 8.641 11.3845 8.78717 11.3845 8.9615C11.3845 9.13583 11.4435 9.282 11.5615 9.4C11.6795 9.518 11.8257 9.577 12 9.577ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z' fill='%23036EB7'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        background-position-x: 0;
        background-position-y: center;
        background-color: white;
        color: #036eb7;
        font-size: 14px;
        line-height: 22px;
        padding-left: 28px;
        padding-bottom: 8px;
        border-bottom: 1px solid #daede1;
        margin-top: 0;
        margin-bottom: 8px;

        @media #{$mobile} {
            margin-top: 20px;
        }
    }

    &__error {
        margin-top: 0;
        background-color: transparent;
        padding: 10px 0;
        @include n-theme() {
            border-bottom: 0;
        }
    }
}
</style>
